'use client';

import { useEffect, useRef, useState } from 'react';

import NavbarLG from './navbar/NavbarLG.jsx';
import NavbarSM from './navbar/NavbarSM.jsx';

const DESKTOP_BREAKPOINT = 992;

const Header = (props) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    const updateViewport = () => {
      setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT);
    };

    updateViewport();
    window.addEventListener('resize', updateViewport);

    return () => {
      window.removeEventListener('resize', updateViewport);
    };
  }, []);

  useEffect(() => {
    const element = headerRef.current;

    if (!element || typeof window === 'undefined') {
      return undefined;
    }

    const publishNavbarHeight = () => {
      document.documentElement.style.setProperty(
        '--navbar-height',
        `${Math.round(element.getBoundingClientRect().height)}px`,
      );
    };

    publishNavbarHeight();

    let resizeObserver;

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(publishNavbarHeight);
      resizeObserver.observe(element);
    } else {
      window.addEventListener('resize', publishNavbarHeight);
    }

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
        return;
      }

      window.removeEventListener('resize', publishNavbarHeight);
    };
  }, []);

  return (
    <header id="header" className="next-app-shell__header" ref={headerRef}>
      <section
        title={props.headerMessages?.sectionTitle || 'navbar wrapper'}
        className="navbar-wrapper bg-primary d-flex flex-column"
      >
        {isDesktop ? <NavbarLG {...props} /> : <NavbarSM {...props} />}
      </section>
    </header>
  );
};

export default Header;
